import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
export function useWidth() {
  var widthRef = React.useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1];

  React.useLayoutEffect(function () {
    var _widthRef$current;

    var w = (_widthRef$current = widthRef.current) === null || _widthRef$current === void 0 ? void 0 : _widthRef$current.getBoundingClientRect().width;
    setWidth(w || 0);
  }, []);
  React.useEffect(function () {
    function handleResize() {
      var _widthRef$current2;

      var w = (_widthRef$current2 = widthRef.current) === null || _widthRef$current2 === void 0 ? void 0 : _widthRef$current2.getBoundingClientRect().width;
      setWidth(w || 0);
    }

    window.addEventListener('resize', handleResize, false);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    widthRef: widthRef,
    width: width
  };
}